import { getStudioExecutionCopy } from "@/i18n/studio-execution-copy";
import { useStudioLocale } from "@/i18n";
import { useStudioStore } from "@/store/studio-store";
import { CogoMark } from "../components/cogo-mark";
import { useStudioProjectOutputKind } from "../components/artifact-mode-switcher";
import {
  activateStudioAuthorityTask,
  isStudioAttentionTargetAvailable,
} from "../studio-authority-activation";
import { useStudioCockpit } from "./use-studio-cockpit";

export function CockpitAttentionHandoff() {
  const { locale } = useStudioLocale();
  const copy = getStudioExecutionCopy(locale).taskCenter;
  const { activeAttention } = useStudioCockpit();
  const outputKind = useStudioProjectOutputKind();
  const markReviewed = useStudioStore(
    (state) => state.markCockpitActivityReviewed,
  );
  const setChatSidebarOpen = useStudioStore(
    (state) => state.setChatSidebarOpen,
  );

  if (!activeAttention) return null;

  const target =
    activeAttention.destination.targetRef ??
    activeAttention.targetRef ??
    activeAttention.title;
  const targetAvailable = isStudioAttentionTargetAvailable(activeAttention);
  const canAcknowledge =
    targetAvailable && activeAttention.resolution === "presented";

  return (
    <div
      className="flex min-h-10 shrink-0 items-center gap-2 border-b border-border bg-muted/40 px-3 py-1.5 text-xs"
      data-testid="cockpit-attention-handoff"
      role="status"
    >
      <CogoMark size={18} variant="speed" />
      <span className="font-medium text-foreground">{copy.attentionTitle}</span>
      <span className="shrink-0 rounded-full bg-background px-2 py-0.5 text-[11px] font-medium text-muted-foreground">
        {copy.state[activeAttention.kind]}
      </span>
      <span className="min-w-0 truncate text-muted-foreground">
        {targetAvailable ? target : copy.targetUnavailable}
      </span>
      {canAcknowledge && (
        <button
          type="button"
          className="ml-auto shrink-0 rounded-md border border-border bg-background px-2 py-1 font-medium text-foreground hover:bg-muted"
          onClick={() => markReviewed(activeAttention.id)}
        >
          {copy.doneReviewing}
        </button>
      )}
      {activeAttention.resolution === "explicit-decision" && (
        <button
          type="button"
          className="ml-auto shrink-0 rounded-md border border-border bg-background px-2 py-1 font-medium text-foreground hover:bg-muted"
          onClick={() => {
            activateStudioAuthorityTask({
              domain: activeAttention.destination.domain,
              outputKind,
              requestedView: activeAttention.destination.authorityView,
              railItem: activeAttention.destination.railItem,
              selection: activeAttention.destination.selection,
              targetRef: activeAttention.destination.targetRef,
              attention: activeAttention,
            });
            setChatSidebarOpen(true);
          }}
        >
          {copy.continueInChat}
        </button>
      )}
    </div>
  );
}
